/**
 * Created by Kieran on 17/10/2017.
 */

import dateFormat from '../../helpers/DatePickerManager'

export default {
  data: function() {
    return {
      isUpdating: false,
      dateFormat: dateFormat,
      maxDate: moment().format('DD-MM-YYYY'),
      timeModel: {
        date: "",
        time: ""
      }
    }
  },
  watch: {
    'timeModel.time': function () {
      let self = this;
      let offset = new Date();
      let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a')
      self.reading.date = moment(dateTime).format();
    },
    'timeModel.date': function () {
      let self = this;
      let offset = new Date();
      let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a')
      self.reading.date = moment(dateTime).format();
    },
  },
  mounted: function() {
    let self = this;
    /**
     * Stop prop from being mutated
     */
    self.reading = JSON.parse(JSON.stringify(self.item));


    let date = moment.utc(self.reading.date_created);
    self.timeModel.time = date.format('hh:mm a');
    self.timeModel.date = date.format('DD-MM-YYYY');

    self.$forceUpdate();

  },
  methods: {
    closeEditMode: function() {
      let self = this;
      self.$emit('closeEditPanel')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/TrackingEditMixin/index.js